import React from "react"
import InstagramEmbed from "react-instagram-embed"
import styled from "styled-components"

const Wrapper = styled.div`
  iframe {
    margin-left: auto !important;
    margin-right: auto !important;
  }
`

const Instagram = ({ url }) => (
  <Wrapper>
    <InstagramEmbed url={url} maxWidth={500} />
  </Wrapper>
)

export default Instagram
